import APIS from 'src/constants/ApiConfig';
import { BaseResult, IPageResult } from 'src/entity/BaseResult';
import {
  ICertificationLevel,
  IDoctorActive,
  IDoctorInfo,
  IDoctorOrderAdd,
  IHospital,
  IBatchModifySupplierParam,
  IBatchSupplierValidateRes,
  IDistributeDocs,
  IRechargeSevenCount,
  ISupplierDict,
} from 'src/entity/DoctorEntity';
import { IDoctorSearch } from 'src/entity/SearchEntity';
import { validateRegionError } from 'src/redux/actions/drugStoreCreator';
import { getLocationChain } from 'src/redux/actions/locationCreator';
import HttpService from 'src/services/HttpService';
import I18N from 'src/services/I18NService';

/**
 * 默认代理商医生类型
 */
export const CertificationLevel: ICertificationLevel[] = [
  {
    value: 0,
    name: '学习用户',
    key: 'doc_certificate_fzy',
    isShow: true,
  },
  {
    value: 1,
    name: '医生用户',
    key: 'doc_certificate_zy',
    isShow: false,
  },
  {
    value: 2,
    name: '医生用户',
    key: 'doc_certificate_zy',
    isShow: true,
  },
  {
    value: 3,
    name: '海外医生',
    key: 'common_oversea',
    isShow: true,
  },
  {
    value: 4,
    name: '医助用户',
    key: 'doc_certificate_zzy',
    isShow: true,
  },
  {
    value: -1,
    name: '业务员',
    key: 'doc_salesman',
    isShow: true,
  },
];


/**
 * 代理商医生Service
 * @class DoctorService
 */
class DoctorService {
  /**
   * 根据条件获取医生列表
   * @memberof DoctorService
   */
  getAgentDoctor = async (query: IDoctorSearch): Promise<IPageResult<IDoctorInfo[]>> => {
    query.institution_type = 0;
    const url = `${APIS.domainApi(APIS.doctor.legacyMembers)}`;
    const res = await HttpService.get(url, query);
    return res;
    // const url = APIS.domainApi(APIS.doctor.members);
    // const res: IPageResult<IDoctorMember[]> = await HttpService.get(url, query);
    // return res;
  };

  // doctorMember2Info(doctor: IDoctorMember): IDoctorInfo {
  //   const result: IDoctorInfo = {
  //     // id: number;
  //     uuid: doctor.doctor,
  //     first_name: doctor.first_name,
  //     last_name: doctor.last_name,
  //     mobile: doctor.mobile,
  //     position: doctor.position,
  //     good_at: doctor.specialization, // 擅长领域

  //     email: doctor.email,
  //     username: doctor.username,
  //     created_time: doctor.created_time,
  //     modified_time: doctor.modified_time,
  //     is_certificated: doctor.is_certified,
  //     // brief: string; // 简介
  //     // code: string;

  //     // is_online_consult: boolean; // 是否在线咨询
  //     // is_phone_consult: boolean; // 是否电话咨询
  //     // is_public: boolean; // 是否公开
  //     // is_reservable: boolean; // 是否可以预约
  //     // is_verified: boolean; // 是否审核
  //   };
  //   return result;
  // }

  /**
   * 获取导出的医生列表数据
   * @memberof DoctorService
   */
  getAgentDoctorForExport = (query: IDoctorSearch): Promise<IPageResult<IDoctorInfo[]>> => {
    query.institution_type = 0;
    const url = `${APIS.domainApi(APIS.doctor.legacyMembers)}`;
    return HttpService.getAll(url, query);
  };

  /**
   * 根据id获取代理商医生信息
   * @memberof DoctorService
   */
  getAgentDoctorInfo = (id: number): Promise<IDoctorInfo> => {
    return HttpService.get(`${APIS.domainApi(APIS.doctor.legacyMembers)}${id}/`);
  };

  getDoctorRechargeSevenCount = (data: { agent_uuid: string; organization_id: number }): Promise<IRechargeSevenCount> => {
    return HttpService.post(`${APIS.domainUrl(APIS.docRechargeSevenDay)}`, data);
  };

  /**
   * 根据UUID获取医生信息
   * @memberof DoctorService
   */
  getDoctorMemberInfo = (UUID: string): Promise<IDoctorInfo> => {
    return HttpService.get(`${APIS.domainApi(APIS.doctor.members)}${UUID}/`);
  };

  /**
   * 医生认证
   * @memberof DoctorService
   */
  changeDoctorCertification = async (doctor: IDoctorInfo, isCertified: boolean, reason?: string): Promise<boolean> => {
    try {
      if (!!doctor && !!doctor.uuid) {
        const url = `${APIS.domainApi(APIS.doctor.doctorCertification)}${doctor.uuid}/certify/`;
        const res = await HttpService.post(url, {
          is_certified: isCertified,
          fail_reason: reason,
        });
        return !!res;
      }
    } catch (error) {
      console.error(error);
    }
    return false;
  };

  /**
   * @description 修改医生配药中心
   */
  updateDoctorDrugStore = async (doctor: IDoctorInfo, drugStoreUUIDList: string[], sales: string): Promise<boolean> => {
    try {
      if (!!doctor && !!doctor.uuid) {
        const ulr = `${APIS.domainApi(APIS.doctor.institutions)}${doctor.hospital}/`;
        const res = await HttpService.patch(ulr, {
          agent_salesman: sales,
          drug_stores: drugStoreUUIDList,
        });
        return !!res;
      }
    } catch (error) {
      console.error(error);
    }
    return false;
  };

  /**
   * 医生审核
   * @memberof DoctorService
   */
  changeDoctorVerification = async (doctor: IDoctorInfo, isVerified: boolean, reason?: string): Promise<boolean> => {
    try {
      if (!!doctor && !!doctor.uuid) {
        const url = `${APIS.domainApi(APIS.doctor.institutions)}${doctor.uuid}/verify/`;
        const res = await HttpService.post(url, {
          is_verified: isVerified,
          reason: reason || 'success',
        });
        return !!res;
      }
    } catch (error) {
      console.error(error);
    }
    return false;
  };

  /**
   * 修改机构医生信息
   *
   */
  changeInstitutionDoctorInfo = async (doctor: IDoctorInfo): Promise<boolean> => {
    try {
      if (!!doctor && !!doctor.uuid) {
        const url = `${APIS.domainApi(APIS.doctor.legacyMembers)}${doctor.id}/`;
        const res = await HttpService.patch(url, {
          agent_salesman: doctor.agent_salesman,
          prescription_right: doctor.prescription_right,
          superior_institution: doctor.superior_institution,
          cooperative_diagnosis_opened: doctor.cooperative_diagnosis_opened,
        });
        return !!res;
      }
    } catch (error) {
      console.error(error);
    }
    return false;
  };

  // /**
  //  * 根据条件获取待认证医生列表
  //  * @memberof DoctorService
  //  */
  // getToBeCertifiedDoctorList = (query: IDoctorSearch): Promise<IPageResult<ICertificationDoctorInfo[]>> => {
  //   const url = `${APIS.domainApi(APIS.doctor.doctorCertification)}?is_certified__isnull=true`;
  //   return HttpService.get(url, query);
  // };

  // /**
  //  * 根据条件获取审核驳回的医生列表
  //  * @memberof DoctorService
  //  */
  // getAgentDoctorReject = (query: IDoctorSearch): Promise<IPageResult<IDoctorInfo[]>> => {
  //   const url = `${APIS.domainApi(APIS.doctor.legacyMembers)}?is_verified=false`;
  //   // const url = `${APIS.domainApi(APIS.doctor.institutions)}?is_verified=false`;
  //   return HttpService.get(url, query);
  //   // return HttpService.get(APIS.domainUrl(APIS.agentDoctorRejected), query);
  // };

  // /**
  //  * 根据id获取代理商审核已驳回医生信息
  //  * @memberof DoctorService
  //  */
  // getAgentDoctorRejectInfo = (id: number): Promise<IDoctorInfo> => {
  //   return HttpService.get(APIS.domainUrl(APIS.agentDoctorRejected) + id + '/');
  // };

  // /**
  //  * 根据待认证记录id获取待认证医生详情
  //  * @memberof DoctorService
  //  */
  // getAgentDoctorCertificationInfo = (recordId: number, doctorUUID: string): Promise<ICertificationDoctorInfo> => {
  //   // const url = `${APIS.domainApi(APIS.doctor.doctors)}${doctorUUID}/`;
  //   return HttpService.get(APIS.domainUrl(APIS.agentDoctorCertification) + recordId + '/');
  // };

  // /**
  //  * 更新待认证医生
  //  * @memberof DoctorService
  //  */
  // updateAgentDoctorCertification = (doctorId: string, data: ISubCertificationDoctorInfo): Promise<any> => {
  //   return HttpService.patch(APIS.domainUrl(APIS.agentDoctorCertification) + doctorId + '/', data);
  // };

  /**
   * 代理商医生新增订单(有效期)
   * @memberof DoctorService
   */
  agentDoctorAddOrder = async (data: IDoctorOrderAdd): Promise<BaseResult<{ out_trade_no: string }> | null> => {
    try {
      // 充值订单接口，/hosp/agent/doctors/addorder/
      // const url = `${APIS.domainUrl(APIS.agentDoctors)}addorder/`;
      const url = `${APIS.domainUrl(APIS['backend-orders'])}`;
      return await HttpService.post(url, data);
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  /**
   * 根据性别代码获取描述
   * @memberof DoctorService
   */
  getGender = (gender: string | number): string => {
    if (gender === 'M' || gender === 0) {
      return I18N.get('common_gender_male');
    } else if (gender === 'F' || gender === 1) {
      return I18N.get('common_gender_female');
    } else if (gender === '') {
      return '';
    }
    return I18N.get('common_gender_unknown');
  };

  /**
   * 根据代理商医生身份value获取对应描述
   *
   * @memberof DoctorService
   */
  getCertificationLevel = (level: number): string => {
    const obj: ICertificationLevel | undefined = CertificationLevel.find((t) => t.value === level);
    if (!!obj) {
      return I18N.get(obj.key);
    }
    return '';
  };

  /**
   * 代理商医生启停
   * @memberof DoctorService
   */
  updateAgentDoctorActive = (doctorUUID: string, isActive: boolean): Promise<any> => {
    // is_active === true 启用 false 停用
    const data: IDoctorActive = {
      is_active: isActive,
    };
    const url = `${APIS.domainApi(APIS.doctor.members)}${doctorUUID}/active-control/`;
    return HttpService.post(url, data);
  };

  /**
   * @description 给销售分配医生
   *
   * @param {number} salesPersonId  销售员id
   * @param {number[]} docIds 医生id数组
   */
  distributeDocToSales(salesPersonUuid: string | null, salesPersonName: string | null, docIds: number[]) {
    const data: IDistributeDocs = {
      doctors: docIds,
      salesperson_name: salesPersonName,
      salesperson_uuid: salesPersonUuid,
    };
    const url = `${APIS.domainApi(APIS.doctor.members)}distribute-doctor-sales/`;
    // const url = `${APIS.domainUrl(APIS.agentDoctors)}distribute-sales/`;
    return HttpService.post(url, data);
  }

  /**
   * @description 获取销售
   *
   */
  getSales(params: { fullname?: string; limit?: number; offset?: number }) {
    // https://qaapi.macrocura.com/partner/members/
    const url = `${APIS.domainApi('/partner/members/')}`;
    return HttpService.get(url, params);
  }
  /**
   * @param uuid 获取销售详情
   * @returns
   */
  getSalesInfo(uuid: string) {
    const url = `${APIS.domainApi(`/partner/members/${uuid}/`)}`;
    return HttpService.get(url);
  }

  getDepartment() {
    const url = `${APIS.domainApi('/partner/departments/')}`;
    return HttpService.getAll(url);
  }

  /**
   * 获取代理商下诊所机构列表(分页)
   * @param agentId: 代理商Id
   * @memberof DoctorService
   */
  private getAgentHospitals = (query: { has_prescription_doctor: boolean; limit?: number; offset?: number }): Promise<IPageResult<IHospital[]>> => {
    const url = `${APIS.domainApi(APIS.doctor.institutions)}`;
    return HttpService.get(url, query);
  };

  /**
   * 获取代理商下诊所机构列表(全部， 前端处理分页接口)
   * 调用2次接口，拿到全部诊所机构列表
   */
  getAllAgentHospitals = async (query: { has_prescription_doctor: boolean; limit?: number; offset?: number }): Promise<IPageResult<IHospital[]>> => {
    query.limit = 200;
    query.offset = 0;
    let result: IPageResult<IHospital[]> = {
      next: '',
      count: 0,
      previous: '',
      results: [],
    };
    try {
      const url = `${APIS.domainApi(APIS.doctor.institutions)}`;
      result = await HttpService.getAll(url, query);
    } catch (error) {
      throw error;
    }
    return result;
  };

  /**
   * 根据获取代理商下医生列表(全部， 前端处理分页接口)
   * 不再获取关联代理商的诊所医生
   */
  getAllAgentRelateDoctors = async (query: IDoctorSearch): Promise<IPageResult<IDoctorInfo[]>> => {
    query.offset = 0;
    query.limit = 100;
    query.institution_type = 0;
    let result: IPageResult<IDoctorInfo[]> = {
      next: '',
      count: 0,
      previous: '',
      results: [],
    };
    try {
      const url = `${APIS.domainApi(APIS.doctor.legacyMembers)}`;
      result = await HttpService.getAll(url, query);
    } catch (error) {
      throw error;
    }
    return result;
  };

  /**
   * 批量编辑医生供应商[新增关联|解除关联]
   */
  batchModifySupplier = async (operateType: 'bind' | 'unBind', param: IBatchModifySupplierParam): Promise<boolean> => {
    const doctorBatchApi = `${APIS.mall.pharmacy}${operateType === 'bind' ? 'batch-link' : 'batch-unlink'}/`;
    const api = APIS.domainApi(doctorBatchApi);
    try {
      const res = await HttpService.put(api, param);
      return !!res;
    } catch (error) {
      console.error(error);
    }
    return false;
  };

  /**
   * 批量处理医生关联配药中心
   */
  batchLinkDrugstore = async (param: { doctors: string[]; drug_store_id: number }): Promise<boolean> => {
    const api = APIS.domainUrl(APIS.batchLinkDrugstore);
    try {
      const res = await HttpService.post(api, param);
      return !!res;
    } catch (error) {
      console.error(error);
    }
    return false;
  };

  /**
   * 医生批量关联供应商单元药库验证(前端验证)
   * 关联代理商单元药库 => 判断医生是否未开通在线订购
   * 关联配药中心单元药库：
   *  1,判断医生是否已开通在线订购
   *  2,判断医生地址是否在配药中心服务中心内
   * @param supplier 关联供应商: [代理商|配药中心]
   * @param doctorList 医生列表
   */
  batchRelateSupplierValidator = (supplier: ISupplierDict, doctorList: IDoctorInfo[]): IBatchSupplierValidateRes => {
    const result: IBatchSupplierValidateRes = {
      err_code: [],
      valid_doctors: [],
    };
    if (supplier.type === 'agent') {
      // 关联代理商单元药库 => 判断医生是否开通在线订购
      let isOnlineOrder = false;
      doctorList.forEach((item) => {
        if (Array.isArray(item.drug_stores) && item.drug_stores.length > 0) {
          // 医生已开通在线订购
          isOnlineOrder = true;
        } else {
          // 医生未开通在线订购 => 医生通过验证
          result.valid_doctors.push(item.uuid);
        }
      });
      if (isOnlineOrder) {
        result.err_code.push('has_online_order_doctors');
      }
    } else {
      // 关联配药中心单元药库
      let isOnlineOrder = true;
      doctorList.forEach((item) => {
        if (Array.isArray(item.drug_stores) && item.drug_stores.length > 0) {
          // 医生已开通在线订购 => 再判断医生地址是否在配药中心服务中心内
          const locationChain = getLocationChain(item.location_id);
          const regionError = validateRegionError(supplier.regions, locationChain);
          if (regionError) {
            // 医生地址不在配药中心服务中心内
            result.err_code.push('has_not_in_regions_doctors');
          } else {
            // 医生地址在配药中心服务中心内 => 医生通过验证
            result.valid_doctors.push(item.uuid);
          }
        } else {
          // 医生未开通在线订购
          isOnlineOrder = false;
        }
      });
      if (!isOnlineOrder) {
        result.err_code.push('has_no_online_order_doctors');
      }
    }
    return result;
  };

  /**
   * 医生批量解除关联供应商单元药库验证(后台验证)
   * 解除关联单元药库 => 判断单元药库是否为医生唯一单元药库
   * @param supplier 关联供应商: [代理商|配药中心]
   * @param doctorList 医生列表
   */
  batchUnrelateSupplierValidator = async (param: IBatchModifySupplierParam): Promise<IBatchSupplierValidateRes> => {
    let result: IBatchSupplierValidateRes = { err_code: [], valid_doctors: [] };
    try {
      const api = APIS.domainApi(`${APIS.mall.pharmacy}batch-unlink-check/`);
      const res: IBatchSupplierValidateRes = await HttpService.put(api, param);
      if (!!res) {
        result = res;
      }
    } catch (error) {
      throw error;
      console.error(error);
    }
    return result;
  };
}

export default new DoctorService();



// WEBPACK FOOTER //
// ./src/services/DoctorService.ts